import { render, staticRenderFns } from "./DeliveryTrackingComponent.vue?vue&type=template&id=673c7349&"
import script from "./DeliveryTrackingComponent.vue?vue&type=script&lang=js&"
export * from "./DeliveryTrackingComponent.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryTrackingComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports